(() => {
  'use strict';

  const $ = (selector, parent = document) => parent.querySelector(selector);
  const $$ = (selector, parent = document) => [...parent.querySelectorAll(selector)];
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = String(text);
    return element;
  };
  let products = {};
  try { products = JSON.parse($('#home-product-data')?.textContent || '{}'); } catch (_) { /* Native forms remain usable. */ }

  const menuButton = $('.menu-button');
  const menu = $('#site-menu');
  const menuGroups = menu ? $$('[data-menu-group-toggle]', menu).map(toggle => ({
    toggle,
    panel: document.getElementById(toggle.getAttribute('aria-controls') || '')
  })).filter(group => group.panel && menu.contains(group.panel)) : [];
  function setMenuGroup(group, open, restoreFocus = true) {
    if (!open && restoreFocus && menu.open && group.panel.contains(document.activeElement)) group.toggle.focus();
    group.toggle.setAttribute('aria-expanded', String(open));
    group.panel.hidden = !open;
  }
  function resetMenuGroups(restoreFocus = true) {
    menuGroups.forEach(group => setMenuGroup(group, false, restoreFocus));
  }
  function syncMenuState() {
    if (!menu || !menuButton) return;
    menuButton.setAttribute('aria-expanded', String(menu.open));
    $$('[data-open-menu-group]').forEach(trigger => trigger.setAttribute('aria-expanded', String(menu.open)));
    menuButton.setAttribute('aria-label', menu.open ? 'Close menu' : 'Open menu');
  }
  function closeMenu(restoreFocus = false) {
    if (!menu || !menuButton) return;
    const wasOpen = menu.open;
    resetMenuGroups();
    if (wasOpen) menu.close();
    syncMenuState();
    if (restoreFocus && wasOpen) menuButton.focus();
  }
  if (menuButton && menu && typeof menu.showModal === 'function') {
    syncMenuState();
    resetMenuGroups(false);
    menuGroups.forEach(group => group.toggle.addEventListener('click', () => {
      const open = group.toggle.getAttribute('aria-expanded') !== 'true';
      group.toggle.focus();
      menuGroups.forEach(other => setMenuGroup(other, other === group && open));
    }));
    menuButton.addEventListener('click', () => {
      if (menu.open) closeMenu(true);
      else { resetMenuGroups(false); menu.showModal(); syncMenuState(); }
    });
    $$('[data-open-menu-group]').forEach(trigger => trigger.addEventListener('click', () => {
      const group = menuGroups.find(item => item.toggle.id === trigger.dataset.openMenuGroup);
      if (!group) return;
      resetMenuGroups(false);
      if (!menu.open) menu.showModal();
      setMenuGroup(group, true, false);
      syncMenuState();
      group.toggle.focus();
    }));
    $('[data-menu-close]', menu)?.addEventListener('click', () => closeMenu(true));
    // Native modal dialogs provide focus containment and make the page inert.
    menu.addEventListener('cancel', event => {
      event.preventDefault();
      closeMenu(true);
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || event.ctrlKey || event.metaKey || event.altKey) return;
      const focusable = $$('a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]', menu).filter(element => {
        const style = window.getComputedStyle(element);
        return element.tabIndex >= 0 && !element.matches(':disabled') && !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.visibility !== 'collapse';
      });
      if (!focusable.length) { event.preventDefault(); return; }
      const first = focusable[0], last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (event.shiftKey && (active === first || !focusable.includes(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !focusable.includes(active))) {
        event.preventDefault();
        first.focus();
      }
    });
    menu.addEventListener('close', () => { resetMenuGroups(false); syncMenuState(); });
    menu.addEventListener('click', event => {
      if (event.target !== menu) return;
      const rect = menu.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeMenu(true);
    });
    $$('a', menu).forEach(link => link.addEventListener('click', event => {
      if (event.defaultPrevented) return;
      let destination = null;
      const keyboardNavigation = event.detail === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && (!link.target || link.target === '_self');
      if (keyboardNavigation) {
        try {
          const url = new URL(link.href, window.location.href);
          const current = new URL(window.location.href);
          if (url.origin === current.origin && url.pathname === current.pathname && url.search === current.search && url.hash.length > 1) {
            destination = document.getElementById(decodeURIComponent(url.hash.slice(1)));
          }
        } catch (_) { /* Let native link navigation handle an invalid fragment. */ }
      }
      closeMenu();
      if (destination) {
        // Continue keyboard navigation in the destination section after closing.
        const previousTabIndex = destination.getAttribute('tabindex');
        if (previousTabIndex === null) {
          destination.setAttribute('tabindex', '-1');
          destination.addEventListener('blur', () => destination.removeAttribute('tabindex'), { once: true });
        }
        destination.focus({ preventScroll: true });
      }
    }));
  }

  const focuses = {
    hydrate: { kicker: 'MEET HYDRO+', title: 'PACK IT. MIX IT. PLAY.', copy: 'Single-serve electrolyte sticks that fit straight into your golf bag. Mix with water before, during or after your round.', label: 'Shop HYDRO+', href: '#product-hydro', facts: [['Flavour', 'Passionfruit'], ['In the box', '10 sticks'], ['Price', products.hydro?.price || 'View product']] },
    train: { kicker: 'MEET CM5', title: 'MAKE IT A DAILY HABIT.', copy: 'Pure, unflavoured micronised creatine monohydrate. A simple addition to the routine you keep in the gym and beyond.', label: 'Shop CM5', href: '#product-cm5', facts: [['Per serving', '5 g creatine'], ['In the tub', '60 servings'], ['Price', products.cm5?.price || 'View product']] },
    recover: { kicker: 'MEET WHEY PRO', title: 'FINISH. REFUEL. REPEAT.', copy: 'Chocolate hazelnut whey protein for after the work. Add it to your post-round or post-training routine.', label: 'Shop Whey Pro', href: '#product-whey', facts: [['Per serving', '25 g protein'], ['In the tub', '27 servings'], ['Price', products.whey?.price || 'View product']] }
  };
  const tabs = $$('[data-focus]');
  function selectTab(tab, focus = false) {
    const data = focuses[tab.dataset.focus];
    const panel = $('#focus-panel'), kicker = $('#focus-kicker'), title = $('#focus-title'), copy = $('#focus-copy'), link = $('#focus-link'), facts = $('#focus-facts');
    if (!data || !panel || !kicker || !title || !copy || !link || !facts) return;
    tabs.forEach(item => {
      item.setAttribute('aria-selected', String(item === tab));
      item.tabIndex = item === tab ? 0 : -1;
    });
    panel.setAttribute('aria-labelledby', tab.id);
    kicker.textContent = data.kicker;
    title.textContent = data.title;
    copy.textContent = data.copy;
    const arrow = make('span', '', '→');
    arrow.setAttribute('aria-hidden', 'true');
    link.replaceChildren(document.createTextNode(data.label + ' '), arrow);
    link.href = data.href;
    facts.replaceChildren(...data.facts.map(([name, value]) => {
      const row = make('div');
      row.append(make('dt', '', name), make('dd', '', value));
      return row;
    }));
    if (focus) tab.focus();
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); selectTab(tabs[next], true); }
    });
  });
  if (tabs.length) selectTab(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);

  const dialog = $('.bag'), items = $('.bag__items'), total = $('.bag__total strong'), checkout = $('.bag-checkout');
  const toast = $('.toast'), closeButton = $('.bag-close'), continueButton = $('.bag-continue');
  const forms = $$('[data-product-form]'), openButtons = $$('[data-bag-open]');
  if (!dialog || !items || !total || !checkout || !closeButton || typeof window.fetch !== 'function' || typeof dialog.showModal !== 'function') return;

  const rawRoot = document.documentElement.dataset.cartRoot || '/';
  const root = /^\/(?!\/)[^?#]*$/.test(rawRoot) ? rawRoot.replace(/\/?$/, '/') : '/';
  const endpoint = path => root + path;
  const checkoutHref = checkout.getAttribute('href') || endpoint('checkout');
  let cart = null, pendingMutation = null, cartRevision = 0, readNumber = 0, loadingReads = 0, toastTimer;
  const status = make('p', 'bag__status');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  status.hidden = true;
  items.before(status);

  function setStatus(message = '', error = false, linkToCart = false) {
    status.replaceChildren(document.createTextNode(message));
    status.hidden = !message;
    status.setAttribute('role', error ? 'alert' : 'status');
    status.classList.toggle('is-error', error);
    if (linkToCart) {
      const link = make('a', '', 'View your cart');
      link.href = endpoint('cart');
      link.style.textDecoration = 'underline';
      status.append(document.createTextNode(' '), link);
    }
  }
  function announce(message, error = false) {
    if (!toast) return;
    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.setAttribute('role', error ? 'alert' : 'status');
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), error ? 6000 : 3000);
  }
  function updateCheckout() {
    const disabled = !cart || !cart.item_count || !!pendingMutation || loadingReads > 0;
    checkout.hidden = !!cart && cart.item_count === 0;
    checkout.setAttribute('aria-disabled', String(disabled));
    checkout.tabIndex = disabled ? -1 : 0;
    if (disabled) checkout.removeAttribute('href');
    else checkout.setAttribute('href', checkoutHref);
  }
  checkout.addEventListener('click', event => {
    if (checkout.getAttribute('aria-disabled') === 'true') event.preventDefault();
  });
  function money(cents, currency) {
    const amount = Number(cents) / 100;
    if (currency === 'ZAR') return 'R' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(amount); }
    catch (_) { return amount.toFixed(2) + ' ' + currency; }
  }
  function safeImage(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, window.location.origin);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }
  function validateCart(value) {
    if (!value || !Array.isArray(value.items) || !Number.isInteger(value.item_count) || !Number.isFinite(value.total_price)) throw new Error('The cart could not be refreshed.');
    for (const item of value.items) {
      if (typeof item.key !== 'string' || !Number.isInteger(item.quantity) || !Number.isFinite(item.final_line_price ?? item.line_price)) throw new Error('The cart could not be refreshed.');
    }
    return value;
  }
  function renderCart(value) {
    cart = validateCart(value);
    const currency = /^[A-Z]{3}$/.test(cart.currency) ? cart.currency : 'ZAR';
    const fragment = document.createDocumentFragment();
    cart.items.forEach(item => {
      const row = make('div', 'bag-item');
      const name = item.product_title || item.title || 'Product';
      const product = Object.values(products).find(value => String(value.variant) === String(item.variant_id));
      const imageURL = safeImage(item.featured_image?.url || item.image || product?.image || '');
      if (imageURL) {
        const image = make('img');
        image.src = imageURL;
        image.alt = name;
        image.loading = 'lazy';
        row.append(image);
      } else {
        const placeholder = make('span', 'bag-item__placeholder');
        placeholder.setAttribute('aria-hidden', 'true');
        row.append(placeholder);
      }
      const details = make('div');
      details.append(make('strong', '', name));
      if (item.variant_title && item.variant_title !== 'Default Title') details.append(make('p', '', item.variant_title));
      if (item.selling_plan_allocation?.selling_plan?.name) details.append(make('p', '', item.selling_plan_allocation.selling_plan.name));
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!key.startsWith('_') && value !== null && value !== '') details.append(make('p', '', `${key}: ${value}`));
      });
      details.append(make('p', '', `Quantity: ${item.quantity}`));
      const discounts = [...new Set((item.line_level_discount_allocations || []).map(allocation => allocation.discount_application?.title).filter(Boolean))];
      discounts.forEach(title => details.append(make('p', 'bag-item__discount', title)));
      const remove = make('button', '', 'Remove');
      remove.type = 'button';
      remove.dataset.remove = item.key;
      remove.setAttribute('aria-label', `Remove ${name} from bag`);
      remove.disabled = !!pendingMutation;
      details.append(remove);
      row.append(details, make('span', '', money(item.final_line_price ?? item.line_price, currency)));
      fragment.append(row);
    });
    if (!cart.items.length) fragment.append(make('p', 'bag-empty', 'Your bag is ready for your first 59 essential.'));
    items.replaceChildren(fragment);
    $$('[data-bag-count]').forEach(count => { count.textContent = String(cart.item_count); });
    total.textContent = money(cart.total_price, currency);
    updateCheckout();
  }
  async function request(path, options = {}) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try {
      const response = await window.fetch(endpoint(path), {
        ...options,
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...options.headers },
        signal: controller.signal
      });
      const body = await response.json().catch(() => null);
      if (!response.ok) {
        const error = new Error(typeof body?.description === 'string' ? body.description : typeof body?.message === 'string' ? body.message : 'The cart could not be updated.');
        error.shopifyResponse = true;
        throw error;
      }
      if (!body) throw new Error('The cart response could not be read.');
      return body;
    } finally { window.clearTimeout(timeout); }
  }
  async function refreshCart() {
    const revision = cartRevision, number = ++readNumber;
    loadingReads++;
    updateCheckout();
    try {
      const value = validateCart(await request('cart.js'));
      if (revision === cartRevision && number === readNumber) renderCart(value);
      return value;
    } finally { loadingReads--; updateCheckout(); }
  }
  function openBag() {
    closeMenu();
    if (!dialog.open) dialog.showModal();
  }
  async function loadBag() {
    openBag();
    setStatus('Loading your bag…');
    try {
      if (pendingMutation) await pendingMutation;
      await refreshCart();
      setStatus();
    } catch (_) { setStatus('Your bag could not be loaded. Please try again.', true, true); }
  }
  openButtons.forEach(button => button.addEventListener('click', event => { event.preventDefault(); loadBag(); }));
  closeButton.addEventListener('click', () => dialog.close());
  continueButton?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });

  async function mutate(work) {
    if (pendingMutation) { announce('Please wait for your bag to finish updating.'); return; }
    cartRevision++;
    const controls = [...forms.flatMap(form => $$('button[type="submit"], [data-add]', form)), ...$$('[data-remove]', dialog)];
    const disabledStates = new Map(controls.map(control => [control, control.disabled]));
    controls.forEach(control => { control.disabled = true; });
    dialog.setAttribute('aria-busy', 'true');
    // Assign the promise before the mutation starts so opening the bag waits for it.
    pendingMutation = Promise.resolve().then(work);
    updateCheckout();
    try { await pendingMutation; }
    finally {
      pendingMutation = null;
      dialog.removeAttribute('aria-busy');
      disabledStates.forEach((wasDisabled, control) => { if (control.isConnected) control.disabled = wasDisabled; });
      $$('[data-remove]', dialog).forEach(button => { button.disabled = false; });
      updateCheckout();
    }
  }
  forms.forEach(form => form.addEventListener('submit', event => {
    // An existing theme handler must never cause a second request.
    if (event.defaultPrevented) return;
    const button = event.submitter || $('[data-add]', form);
    if (!button) return;
    const data = new FormData(form);
    const quantity = Number(data.get('quantity') || 1);
    if (!/^\d+$/.test(String(data.get('id') || '')) || !Number.isSafeInteger(quantity) || quantity < 1) return;
    event.preventDefault();
    // Prevent later bubbling theme listeners from processing the same native form.
    event.stopPropagation();
    if (pendingMutation) { announce('Please wait for your bag to finish updating.'); return; }
    const product = products[button.dataset.add];
    const label = product?.name || 'Product';
    const buttonContents = [...button.childNodes].map(node => node.cloneNode(true));
    form.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding…';
    mutate(async () => {
      let added = false;
      try {
        await request('cart/add.js', { method: 'POST', body: data });
        added = true;
        cartRevision++;
        await refreshCart();
        setStatus();
        announce(`${label} added to your bag.`);
        openBag();
      } catch (error) {
        // Never retry an uncertain POST: it may already have added the item.
        const message = added ? 'Item added. Your bag could not be refreshed; view your cart to continue.' : error.shopifyResponse ? error.message : 'We could not confirm the update. Check your cart before trying again.';
        setStatus(message, true, true);
        announce(message, true);
        openBag();
        try { cartRevision++; await refreshCart(); } catch (_) { cart = null; updateCheckout(); }
      } finally {
        button.replaceChildren(...buttonContents);
        form.removeAttribute('aria-busy');
      }
    });
  }));
  items.addEventListener('click', event => {
    const button = event.target.closest('[data-remove]');
    if (!button || !items.contains(button) || pendingMutation) return;
    const key = button.dataset.remove;
    if (!cart?.items.some(item => item.key === key)) return;
    const restoreFocus = document.activeElement === button;
    mutate(async () => {
      setStatus('Removing item…');
      try {
        const value = await request('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
        cartRevision++;
        renderCart(value);
        setStatus('Item removed.');
      } catch (error) {
        setStatus(error.shopifyResponse ? error.message : 'We could not confirm the update. Check your cart before trying again.', true, true);
        try { cartRevision++; await refreshCart(); } catch (_) { cart = null; updateCheckout(); }
      } finally {
        if (restoreFocus && dialog.open) closeButton.focus();
      }
    });
  });

  updateCheckout();
  refreshCart().catch(() => { /* Read again when the customer opens the bag. */ });
  window.addEventListener('pageshow', event => { if (event.persisted && !pendingMutation) refreshCart().catch(() => {}); });
})();

/* Compact retailer finder — progressive enhancement of the full store directory. */
(() => {
  const root = document.querySelector('[data-retailer-finder]');
  if (!root || root.classList.contains('is-ready')) return;

  const find = selector => root.querySelector(selector);
  const controls = find('[data-retail-controls]');
  const search = find('[data-retail-search]');
  const province = find('[data-retail-province]');
  const reset = find('[data-retail-reset]');
  const status = find('[data-retail-status]');
  const grid = find('[data-retail-grid]');
  const panel = find('[data-retail-panel]');
  const selectedContent = find('[data-retail-selected]');
  const empty = find('[data-retail-empty]');
  const clear = find('[data-retail-clear]');
  const pagination = find('[data-retail-pagination]');
  const previous = find('[data-retail-prev]');
  const next = find('[data-retail-next]');
  const pageLabel = find('[data-retail-page]');
  const dialog = find('[data-retail-dialog]');
  const dialogContent = find('[data-retail-dialog-content]');
  const close = find('[data-retail-close]');
  if ([controls, search, province, reset, status, grid, panel, selectedContent,
    empty, clear, pagination, previous, next, pageLabel, dialog, dialogContent, close]
    .some(element => !element) || typeof dialog.showModal !== 'function') return;

  const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const records = [...grid.querySelectorAll('[data-retailer]')].map(card => ({
    card,
    button: card.querySelector('[data-store-select]'),
    logo: card.querySelector('.retail-card__logo-frame'),
    details: card.querySelector('[data-store-details]'),
    province: normalise(card.dataset.province || ''),
    text: normalise(`${card.textContent} ${card.dataset.province || ''} ${card.dataset.aliases || ''}`)
  }));
  if (!records.length || records.some(record => !record.button || !record.logo || !record.details)) return;

  const mobile = window.matchMedia('(max-width: 600px)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let matches = records;
  let page = 0;
  let selected = null;
  let returnFocus = null;
  const pageSize = () => mobile.matches ? 4 : 6;
  const totalPages = () => Math.max(1, Math.ceil(matches.length / pageSize()));

  function copyDetails(record, destination) {
    const logo = record.logo.cloneNode(true);
    const details = record.details.cloneNode(true);
    [logo, details].forEach(copy => {
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
    });
    const image = logo.querySelector('img');
    if (image) image.loading = 'eager';
    details.hidden = false;
    destination.replaceChildren(logo, details);
  }

  function selectStore(record) {
    selected = record;
    records.forEach(item => {
      const active = item === record;
      item.card.classList.toggle('is-selected', active);
      item.button.setAttribute('aria-pressed', String(active));
    });
    panel.hidden = mobile.matches || !record;
    if (record) copyDetails(record, selectedContent);
    else selectedContent.replaceChildren();
  }

  function render(preferredRecord) {
    page = Math.min(Math.max(0, page), totalPages() - 1);
    const start = page * pageSize();
    const visible = matches.slice(start, start + pageSize());
    records.forEach(record => {
      record.card.hidden = !visible.includes(record);
      record.button.setAttribute('aria-controls', mobile.matches ? dialog.id : panel.id);
      if (mobile.matches) record.button.setAttribute('aria-haspopup', 'dialog');
      else record.button.removeAttribute('aria-haspopup');
    });
    selectStore(visible.includes(preferredRecord) ? preferredRecord : visible[0] || null);
    empty.hidden = matches.length > 0;
    status.textContent = matches.length
      ? `Showing ${start + 1}\u2013${start + visible.length} of ${matches.length} stores`
      : 'No stores found';
    pageLabel.textContent = `Page ${page + 1} of ${totalPages()}`;
    previous.disabled = page === 0;
    next.disabled = page === totalPages() - 1;
    pagination.hidden = matches.length === 0;
  }

  function filter() {
    const terms = normalise(search.value).split(' ').filter(Boolean);
    const chosenProvince = normalise(province.value);
    matches = records.filter(record => (!chosenProvince || record.province === chosenProvince)
      && terms.every(term => record.text.includes(term)));
    page = 0;
    render();
  }

  function resetFilters() {
    search.value = '';
    province.value = '';
    filter();
  }

  function closeDialog() {
    if (dialog.open) dialog.close();
  }

  function openDialog(record) {
    selectStore(record);
    returnFocus = record.button;
    copyDetails(record, dialogContent);
    dialog.showModal();
    close.focus();
  }

  function revealHash(moveFocus) {
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
    const record = records.find(item => item.card.id === id);
    if (!record) return;
    search.value = '';
    province.value = '';
    matches = records;
    page = Math.floor(records.indexOf(record) / pageSize());
    render(record);
    window.requestAnimationFrame(() => {
      record.card.scrollIntoView({ block: 'nearest' });
      if (moveFocus) record.button.focus({ preventScroll: true });
    });
  }

  controls.addEventListener('submit', event => { event.preventDefault(); filter(); });
  search.addEventListener('input', filter);
  province.addEventListener('change', filter);
  reset.addEventListener('click', resetFilters);
  clear.addEventListener('click', () => { resetFilters(); search.focus(); });
  previous.addEventListener('click', () => { page -= 1; render(); });
  next.addEventListener('click', () => { page += 1; render(); });
  records.forEach(record => {
    record.button.addEventListener('mouseenter', () => {
      if (!mobile.matches && finePointer.matches && !panel.contains(document.activeElement)) {
        selectStore(record);
      }
    });
    record.button.addEventListener('focus', () => {
      if (!mobile.matches) selectStore(record);
    });
    record.button.addEventListener('click', event => {
      if (mobile.matches) openDialog(record);
      else {
        selectStore(record);
        if (event.detail === 0) {
          const firstDetailLink = selectedContent.querySelector('a[href]');
          if (firstDetailLink) firstDetailLink.focus({ preventScroll: true });
        }
      }
    });
  });
  close.addEventListener('click', closeDialog);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right
      || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
  dialog.addEventListener('close', () => {
    const target = returnFocus;
    returnFocus = null;
    if (target && target.getClientRects().length) target.focus({ preventScroll: true });
  });
  dialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')]
      .filter(element => element.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  });
  function changeLayout() {
    const retain = selected;
    if (!mobile.matches) closeDialog();
    const index = matches.indexOf(retain);
    page = index < 0 ? 0 : Math.floor(index / pageSize());
    render(retain);
  }
  if (mobile.addEventListener) mobile.addEventListener('change', changeLayout);
  else mobile.addListener(changeLayout);
  window.addEventListener('hashchange', () => revealHash(true));

  root.classList.add('is-ready');
  controls.hidden = false;
  render();
  revealHash(false);
})();
